import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import i18n from '@/i18n'
import { createStore } from 'vuex'
import stores from './store/index'
// import { initializeApp } from "firebase/app";
import '@/assets/css/modern.css'

import '@/assets/js/app'
import '@/assets/css/dcp.css'

import ApiService from '@/assets/js/apiService'; // 引入 ApiService 實例
import shareds from '@/assets/js/shared.js'
import Parameters from '@/assets/js/parameters'
import D_LocalStorage from '@/assets/js/D_LocalStorage'

const store = createStore(stores)
const app = createApp(App);

const apiService = new ApiService(app);
app.config.globalProperties.$api = apiService;
const parameter = new Parameters()
app.config.globalProperties.$parameter = parameter;
const shared = new shareds()
app.config.globalProperties.$shared = shared;
const DLS = new D_LocalStorage()
app.config.globalProperties.$DLS = DLS;

import packageJson from '../package.json'
app.config.globalProperties.$version = process.env.VUE_APP_ENV_NAME === 'production' ? packageJson.version : `${process.env.VUE_APP_ENV_NAME}.${packageJson.version}`
console.log(`version:` , app.config.globalProperties.$version)
app.use(router);
app.use(store);
app.use(i18n)
app.mount('#app');
  
export { apiService, store }; // ✅ 匯出 `apiService` 和 `store`